// style
import './style/home.css'
import './style/responsive.css'
import '../../../components/slider/style/banner.css'
// hooks
import { useEffect, useRef, useState } from "react";
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import "swiper/css/pagination"
import "swiper/css/navigation"
// component
import Slider from "../../../components/slider/slider";
import { IconUserCircle } from '@tabler/icons-react';

const useScrollAnimation = (containerRef: React.RefObject<HTMLElement>) => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    } else {
                        entry.target.classList.remove('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        const container = containerRef.current;
        // @ts-ignore
        const items = container?.querySelectorAll('.animated-element');

        if (items) {
            items.forEach((item) => observer.observe(item));
        }

        return () => {
            if (items) {
                items.forEach((item) => observer.unobserve(item));
            }
        };
    }, [containerRef]);
};

const Home = () => {
    const swiperRef = useRef<any>(null);
    const content = useRef<any | null>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [scrollAllowed, setScrollAllowed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);
    const handleSlideChange = (swiper: any) => {
        setActiveIndex(swiper.activeIndex);
        if (swiper.activeIndex === 4) {
            setTimeout(() => {
                setScrollAllowed(true);
            }, 1000);
        } else {
            setScrollAllowed(false);
        }
    };
    const handleWheel = (event: any) => {
        if (event.deltaY > 10 && scrollAllowed) {
            if (content.current) {
                const imagePosition = content.current.getBoundingClientRect().top + window.scrollY;
                const offset = 10;
                window.scrollTo({
                    top: imagePosition + offset,
                    behavior: 'smooth',
                });
                document.body.style.overflow = 'visible';
            }
        }
    };

    const handleTouchStart = (event: any) => {
        const touchStartY = event.touches[0].clientY;
        event.target.setAttribute('data-touch-start', touchStartY);
    };

    const handleTouchEnd = (event: any) => {
        const touchStartY = parseFloat(event.target.getAttribute('data-touch-start'));
        const touchEndY = event.changedTouches[0].clientY;
        if (touchStartY > touchEndY) {
            if (content.current) {
                const imagePosition = content.current.getBoundingClientRect().top + window.scrollY;
                const offset = 10;
                window.scrollTo({
                    top: imagePosition + offset,
                    behavior: 'smooth',
                });
                document.body.style.overflow = 'visible';
            }
        }
    };
    const keyEvent = (event: any) => {
        const swiper = swiperRef.current.swiper;
        if (event.key === 'ArrowDown' || event.key === 'ArrowLeft') {
            event.preventDefault()
            // eslint-disable-next-line eqeqeq
            if (swiper.activeIndex == 4) {
                const imagePosition = content.current.getBoundingClientRect().top + window.scrollY;
                const offset = 10;
                window.scrollTo({
                    top: imagePosition + offset,
                    behavior: 'smooth',
                });
                document.body.style.overflow = 'visible';
            }
            swiper.slideNext();
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
            event.preventDefault()
            swiper.slidePrev();
        }
    }
    const containerRef = useRef<HTMLDivElement | any>();
    useScrollAnimation(containerRef);
    useEffect(() => {
        document.getElementById('site-main')?.classList.add('main-content')
        document.getElementById('site-main')?.classList.remove('bg-payment-new')
        document.getElementById('site-main')?.classList.remove('bg-payment-new-home')
        document.getElementById('site-main')?.classList.remove('bg-payment-new-error')
        document.getElementById('site-main')?.classList.remove('bg-white')
        mouseScrollTop()
        window.addEventListener('keydown', keyEvent);
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1000);
        };
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (!isMobile && scrollTop === 0) {
            document.body.style.overflow = 'hidden';
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('keydown', keyEvent);
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const mouseScrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const scrollButton = () => {
        // mouseScrollTop();
        // setActiveIndex(0)
        // if (swiperRef.current && swiperRef.current.swiper) {
        //     swiperRef.current.swiper.slideTo(0);
        // }
        window.open('https://client.irantarakonesh.ir/login', '_self')
    }

    if (isMobile) {
        return (
            <>
                {activeIndex == 0 ?
                    null : (
                        <>
                            <button onClick={scrollButton} style={{ position: 'fixed', top: '20px', left: '20px', zIndex: '9999999999' }} className='btn btn-site rounded rounded-4'>
                                <IconUserCircle className='ms-2 align-middle' size={20} />
                                ورود / ثبت نام
                            </button>
                        </>
                    )}
                <Slider
                    mouseEvent={mouseScrollTop}
                    handleSlideChange={handleSlideChange}
                    handleWheel={handleWheel}
                    handleTouchStart={handleTouchStart}
                    handleTouchEnd={handleTouchEnd}
                    swiperRef={swiperRef}
                    activeIndex={activeIndex}
                />
                <article
                    ref={containerRef}
                    className={'home show-scroll h-100 '}>
                    <section
                        ref={content}
                        className={'banner-image mobile-banner-image'}
                        id={'first-banner'}>
                        <div className={'container h-100'}>
                            <div className={'row justify-content-center h-100 overflow-hidden'}>
                                <div className={'col-md-9 col-11 py-4'}>
                                    <div
                                        className={'detail-card'}>
                                        <h1 className={'fw-bold text-black text-center'}>
                                            ایران تراکنش چیه؟
                                        </h1>
                                        <p className={'card-text text-black mt-3 line-18'}>
                                            ایران تراکنش یه سرویس پیشرفته بر بستر تلفن همراه برای انجام پرداخت‌های
                                            روزمره و مدیریت تراکنش‌هاس که به شما کمک می‌کنه به راحتی و با امنیت بالا،
                                            پرداخت‌های خودتون رو انجام بدین. با استفاده از ایران تراکنش، شما می‌تونین
                                            پرداخت‌های روزمره‌تون رو تا 400 میلیون تومن! سریع و بدون دردسر انجام بدین.
                                            این سرویس تمام نیازهای مالی شما رو پوشش می‌ده، از خریدهای آنلاین گرفته تا
                                            خریدهای حضوری و ...
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'ability bg-white py-4 position-relative'}>
                        <div className={'container-fluid'}>
                            <div className={'row justify-content-center'}>
                                <div className={'col-md-6 animated-element'}>
                                    <div className={'d-flex justify-content-start align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_01 1.webp')}
                                            className={'ability-image-mobile'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title line-30 h5 fw-bold mt-5'}>
                                                بدون نیاز به
                                                <div className={'divider-br'}></div>
                                                اپلیکیشـــن
                                            </p>
                                        </div>
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        برعکس تمامی راه های موبایلی تراکنش، ایران تراکنش نیازی به اپلیکیشن نداره
                                        و
                                        در بستر USSD کاملا در دسترسه
                                    </p>
                                </div>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex justify-content-end align-items-center'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5 px-3'}>
                                                در یک چشم
                                                <div className={'divider-br'}></div>
                                                بهــــم زدن
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_02.webp')}
                                            className={'ability-image-mobile'} />
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        حتی سریع تر از ساتنا و پایا از ایران تراکنش می‌تونین استفاده کنین
                                    </p>
                                </div>
                            </div>
                            <div className={'row justify-content-center'}>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex justify-content-start align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_05.webp')}
                                            className={'ability-image-mobile'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5'}>
                                                آسان‌ترین روش
                                            </p>
                                        </div>
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        راحت ترین روش شناخته شده تراکنش، برای انواع مبالغ، ایران تراکنشه
                                    </p>
                                </div>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex align-items-center justify-content-end'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5'}>
                                                ایمن ترین روش
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_04.webp')}
                                            className={'ability-image-mobile'} />
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        دیگه کارتت توسط اسکیمرها کپی نمی‌شه و لینک های ایران تراکنش کاملا امنه.
                                        بستر
                                        USSD ‌و مخابرات خیلی امن تر از اینترنته.
                                    </p>
                                </div>
                            </div>
                            <div className={'row justify-content-center'}>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex align-items-center justify-content-start'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_03.webp')}
                                            className={'ability-image-mobile'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5'}>
                                                تایید پرداخت فوری
                                            </p>
                                        </div>
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        به محض این که پرداخت صورت بگیره، هم برای پرداخت‌کننده هم پذیرنده پیامک
                                        تایید
                                        انتقال میاد. حتی در مبالغ بالا
                                    </p>
                                </div>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex align-items-center justify-content-end'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5'}>
                                                رسید امن
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_06.webp')}
                                            className={'ability-image-mobile'} />
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        به محض انجام تراکنش برای حفظ امنیت، رسیدش از سر شماره اختصاصی با نام
                                        پذیرنده، برات پیامک می‌شه.
                                    </p>
                                </div>
                            </div>
                            <div className={'row justify-content-center'}>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex align-items-center justify-content-start'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_07 1.webp')}
                                            className={'ability-image-mobile'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mt-5'}>
                                                پرداخت با
                                                <div className={'divider-br'}></div>
                                                مبالغ بــالا
                                            </p>
                                        </div>
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        مبالغ بالا تا 400 میلیون تومن رو در هر تراکنش می‌تونین به راحتی انتقال بدین
                                    </p>
                                </div>
                                <div className={'col-md-6 mt-4 animated-element'}>
                                    <div className={'d-flex align-items-center justify-content-end'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 mt-5 fw-bold px-3'}>
                                                بــدون نیـاز به
                                                <div className={'divider-br'}></div>
                                                گوشی هوشمند
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_08 1.webp')}
                                            className={'ability-image-mobile'} />
                                    </div>
                                    <p className={'card-text text-site line-30 mt-3 px-3'}>
                                        ایران تراکنش برای مبالغ خرد تا سقف ۲۰۰ هزار تومن تماما بر بستر ussd انجام میشه و
                                        حتی نیازی به گوشی هوشمند نداره
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'banner-image mobile-second-banner position-relative'}>
                        <div className={'mobile-title-page p-2 position-absolute bottom-0'}>
                            <div className={'d-flex align-items-center justify-content-end h-100'}>
                                <p className={'h5 text-center text-white fw-bold mb-0 mt-5'}>
                                    اجزای سرویس دهنده ایران‌تراکنش
                                </p>
                            </div>
                        </div>
                    </section>
                    <section className={'banner-image mobile-supporter py-md-4 py-0 overflow-hidden'}>
                        <div className={'supporter-slider container h-100'}>
                            <div className={'row justify-content-center align-items-center mt-support'}>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-02.webp')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-04.png')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-01.webp')} />
                                </div>
                                <div className={'col-4 text-center'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-09.webp')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-03.webp')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-06.webp')} />
                                </div>
                                <div className={'col-4 text-center'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-11.webp')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-05.webp')} />
                                </div>
                                <div className={'col-4 text-center'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-10.webp')} />
                                </div>
                                <div className={'col-4 text-center mb-4'}>
                                    <img className={'img-fluid'} alt={'supporter'}
                                        src={require('../../../assets/media/images/suporters/Hamkaran 03-07.webp')} />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'mobile-third-banner text-center'}>
                        <img alt={'banner'} className={'img-fluid'}
                            src={require('./../../../assets/media/images/global/mobile_banner_third.webp')} />
                        <div className={'container'}>
                            <div className={'row justify-content-center'}>
                                <div className={'col-11'}>
                                    <div
                                        className={'detail-card'}>
                                        <p className={'card-text text-white mb-4 line-18'} style={{ wordSpacing: '-4px' }}>
                                            یکی از ویژگی‌های مهم ایران‌تراکنش، امنیت فوق‌العاده اونه که به شما اطمینــان
                                            می‌ده تراکنش‌های مالی‌تون با امنیت بـالا انجام شه. علاوه بر این، سرعت بالا و
                                            کارمزدهای کمتر، از دیگر مزایای این سیستمه که ایران تراکنش رو به انتخابی
                                            محبوب
                                            برای کاربرا تبدیل کرده. ایران تراکنش همچنین به شما این امکان رو می‌ده تا
                                            تراکنش‌های
                                            خودتون رو به راحتــی پیگیـری کنین و گزارش‌های مــالی دقیقــی داشته باشین.
                                            خیلی
                                            ساده بخوام بگم، با ایران‌تراکنش، مدیریت مالی‌تون ساده‌تر، سریع تر، امن تر و
                                            کارآمدتر خواهد شد!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'banner-image fourth-banner position-relative'}>
                        <div className={'E-nemad'} style={{ position: 'fixed', bottom: '20px', left: '20px', zIndex: '9999999999' }} >
                            <a referrerPolicy='origin' target='_blank'
                                href='https://trustseal.enamad.ir/?id=236620&Code=RZJ7fvI0SqjPIEaV3dAV'>
                                {/* @ts-ignore */}
                                <img referrerPolicy='origin'
                                    style={{ width: 100, height: 100, objectFit: 'contain' }}
                                    src='https://trustseal.enamad.ir/logo.aspx?id=236620&Code=RZJ7fvI0SqjPIEaV3dAV'
                                    alt=''
                                    data-code='RZJ7fvI0SqjPIEaV3dAV' />
                            </a>
                        </div>
                    </section>
                </article>
            </>
        )
    } else {
        return (
            <>
                <Slider
                    handleSlideChange={handleSlideChange}
                    handleWheel={handleWheel}
                    handleTouchStart={handleTouchStart}
                    handleTouchEnd={handleTouchEnd}
                    swiperRef={swiperRef}
                    activeIndex={activeIndex}
                />
                <article
                    ref={containerRef}
                    className={'home h-100'}>
                    {activeIndex == 0 ?
                        null : (
                            <>
                                <button onClick={scrollButton} style={{ position: 'fixed', top: '20px', left: '20px', zIndex: '9999999999' }} className='btn btn-site rounded rounded-4'>
                                    <IconUserCircle className='ms-2 align-middle' size={20} />
                                    ورود / ثبت نام
                                </button>
                            </>
                        )}
                    <section
                        ref={content}
                        className={'banner-image'}
                        id={'first-banner'}>
                        <div className={'container h-100'}>
                            <div className={'row h-100 align-items-center overflow-hidden'}>
                                <div className={'col-md-6 col-sm-8 col-12'}>
                                    <div
                                        className={'detail-card'}>
                                        <h1 className={'h2 fw-bold text-black text-center'}>
                                            ایران تراکنش چیه؟
                                        </h1>
                                        <p className={'card-text mt-3 letter-space font-medium-lg font-large-md text-black line-18'}>
                                            ایران تراکنش یه سرویس پیشرفته بر بستر تلفن همراه برای انجام پرداخت‌های
                                            روزمره و مدیریت تراکنش‌هاس که به شما کمک می‌کنه به راحتی و با امنیت بالا،
                                            پرداخت‌های خودتون رو انجام بدین. با استفاده از ایران تراکنش، شما می‌تونین
                                            پرداخت‌های روزمره‌تون رو تا 400 میلیون تومن! سریع و بدون دردسر انجام بدین.
                                            این سرویس تمام نیازهای مالی شما رو پوشش می‌ده، از خریدهای آنلاین گرفته
                                            تا
                                            خریدهای حضوری و ...
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'banner-image second-banner'}></section>
                    <section className={'ability bg-white py-4 position-relative'}>
                        <div className={'container-fluid'}>
                            <div className={'row justify-content-center'}>
                                <div className={'col-md-6 animated-element animated-element-lg animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_01 1.webp')}
                                            className={'ability-img'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold mb-0'}>
                                                بدون نیاز به اپلیکیشن
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                برعکس تمامی راه های موبایلی تراکنش، ایران تراکنش نیازی به اپلیکیشن نداره
                                                و
                                                در بستر USSD کاملا در دسترسه
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={'col-md-6 mt-ability animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                در یک چشم بهم زدن
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                حتی سریع تر از ساتنا و پایا از ایران تراکنش می‌تونین استفاده کنین
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_02.webp')}
                                            className={'ability-img'} />
                                    </div>
                                </div>
                            </div>
                            <div className={'row justify-content-center mt-mine-ability'}>
                                <div className={'col-md-6 animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_05.webp')}
                                            className={'ability-img'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                آسان ترین روش
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                راحت ترین روش شناخته شده تراکنش، برای انواع مبالغ، ایران تراکنشه
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={'col-md-6 mt-ability animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                ایمن ترین روش
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                دیگه کارتت توسط اسکیمرها کپی نمی‌شه و لینک های ایران تراکنش کاملا امنه.
                                                بستر
                                                USSD ‌و مخابرات خیلی امن تر از اینترنته.
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_04.webp')}
                                            className={'ability-img'} />
                                    </div>
                                </div>
                            </div>
                            <div className={'row justify-content-center mt-mine-ability'}>
                                <div className={'col-md-6 animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_03.webp')}
                                            className={'ability-img'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                تایید پرداخت فوری
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                به محض این که پرداخت صورت بگیره، هم برای پرداخت‌کننده هم پذیرنده پیامک
                                                تایید
                                                انتقال میاد. حتی در مبالغ بالا
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={'col-md-6 mt-ability animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                رسید امن
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                به محض انجام تراکنش برای حفظ امنیت، رسیدش از سر شماره اختصاصی با نام
                                                پذیرنده، برات پیامک می‌شه.
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_06.webp')}
                                            className={'ability-img'} />
                                    </div>
                                </div>
                            </div>
                            <div className={'row justify-content-center mt-mine-ability'}>
                                <div className={'col-md-6 animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_07 1.webp')}
                                            className={'ability-img'} />
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                پرداخت با مبالغ بالا
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                مبالغ بالا تا 400 میلیون تومن رو در هر تراکنش می‌تونین به راحتی انتقال
                                                بدین
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={'col-md-6 mt-ability animated-element animated-element-lg'}>
                                    <div className={'d-flex align-items-center'}>
                                        <div className={'text-content'}>
                                            <p className={'card-title h5 fw-bold'}>
                                                بدون نیاز به گوشی هوشمند
                                            </p>
                                            <p className={'card-text text-site line-30 mt-3'}>
                                                ایران تراکنش برای مبالغ خرد تا سقف ۲۰۰ هزار تومن تماما بر بستر ussd
                                                انجام میشه و حتی نیازی به گوشی هوشمند نداره
                                            </p>
                                        </div>
                                        <img alt={'ability'}
                                            src={require('./../../../assets/media/images/ability/ICONS_08 1.webp')}
                                            className={'ability-img'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'title-page p-2'}>
                            <div className={'d-flex align-items-center h-100'}>
                                <p className={'h2 text-white fw-bold mb-0 mt-3'}>
                                    اجزای سرویس دهنده ایران‌تراکنش
                                </p>
                            </div>
                        </div>
                    </section>
                    <div className={'overflow-x-hidden supporter-container overflow-y-visible py-5'}>
                        <div className={'supporter py-5'}>
                            <div className={'supporter-slider'}>
                                <Swiper
                                    spaceBetween={30}
                                    slidesPerView={10}
                                    grabCursor={true}
                                    freeMode={true}
                                    speed={1000}
                                    loop={true}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                    }}
                                    modules={[Autoplay]}
                                    breakpoints={{
                                        320: {
                                            slidesPerView: 4,
                                        },
                                        768: {
                                            slidesPerView: 10,
                                        },
                                    }}
                                >
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-08.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-07.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-06.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-04.png')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-01.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-02.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-03.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-05.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-09.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-10.webp')} />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img className={'img-fluid'} alt={'supporter'}
                                            src={require('../../../assets/media/images/suporters/Hamkaran 03-11.webp')} />
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <section className={'banner-image third-banner'}>
                        <div className={'container h-100'}>
                            <div className={'row h-100 align-items-center overflow-hidden'}>
                                <div className={'col-md-5 col-sm-8 col-12'}>
                                    <div
                                        className={'detail-card'}>
                                        <p className={'card-text font-medium-lg text-white line-18'} style={{ wordSpacing: '-4px' }}>
                                            یکی از ویژگی‌های مهم ایران‌تراکنش، امنیت فوق‌العاده اونه که به شما اطمینــان
                                            می‌ده تراکنش‌های مالی‌تون با امنیت بـالا انجام شه. علاوه بر این، سرعت بالا و
                                            کارمزدهای کمتر، از دیگر مزایای این سیستمه که ایران تراکنش رو به انتخابی
                                            محبوب
                                            برای کاربرا تبدیل کرده. ایران تراکنش همچنین به شما این امکان رو می‌ده تا
                                            تراکنش‌های
                                            خودتون رو به راحتــی پیگیـری کنین و گزارش‌های مــالی دقیقــی داشته باشین.
                                            خیلی
                                            ساده بخوام بگم، با ایران‌تراکنش، مدیریت مالی‌تون ساده‌تر، سریع تر، امن تر و
                                            کارآمدتر خواهد شد!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={'banner-image fourth-banner position-relative'}>
                        <div className='d-flex align-items-end h-100'  >
                            <div className={'E-nemad'} style={{ position: 'fixed', bottom: '20px', left: '20px', zIndex: '9999999999' }}>
                                <a referrerPolicy='origin' target='_blank'
                                    href='https://trustseal.enamad.ir/?id=236620&Code=RZJ7fvI0SqjPIEaV3dAV'>
                                    {/* @ts-ignore */}
                                    <img referrerPolicy='origin'
                                        src='https://trustseal.enamad.ir/logo.aspx?id=236620&Code=RZJ7fvI0SqjPIEaV3dAV'
                                        alt=''
                                        data-code='RZJ7fvI0SqjPIEaV3dAV' />
                                </a>
                            </div>
                        </div>
                    </section>
                </article>
            </>
        )
    }
}

export default Home;